import { isBoolean } from 'lodash';
import { connect } from 'react-redux';
import { compose, withHandlers, withProps, withState } from 'recompose';

const createFiltersFromList = (items) => {
  if (!items || !items.length) {
    return [];
  }

  const uncategorisedOption = {
    id: 'uncategorised',
    title: 'Uncategorised',
    checked: true,
  };

  const rest = items.map(item => ({
    checked: true,
    id: item.id,
    title: item.name,
  }));

  return [uncategorisedOption, ...rest];
};

export default compose(
  connect(state => ({
    brands: state.products.brands.items,
    categories: state.products.categories.items,
  })),
  withState('brandFilters', 'setBrandFilters', ({ brands }) => createFiltersFromList(brands)),
  withState('categoryFilters', 'setCategoryFilters', ({ categories }) => createFiltersFromList(categories)),
  withState('searchText', 'setSearchText', ''),
  withHandlers({
    updateFilter: props => (type, filterOrModifier) => {
      const filters = type === 'brand' ? props.brandFilters : props.categoryFilters;
      const setValue = type === 'brand' ? props.setBrandFilters : props.setCategoryFilters;
      let nextValue;

      if (isBoolean(filterOrModifier)) {
        nextValue = filters.map(f => ({ ...f, checked: filterOrModifier }));
      } else {
        nextValue = filters.map((f) => {
          if (f.id === filterOrModifier.id) {
            return { ...f, checked: !f.checked };
          }
          return f;
        });
      }

      setValue(nextValue);
    },
  }),
  withHandlers({
    onCategoryFilterChange: props => (filterOrModifier) => {
      props.updateFilter('category', filterOrModifier);
    },
    onBrandFilterChange: props => (filterOrModifier) => {
      props.updateFilter('brand', filterOrModifier);
    },
    onSearchChange: props => (e) => {
      props.setSearchText(e.target.value);
    },
  }),
  withProps((props) => {
    const products = props.products.filter((product) => {
      const brandId = product.productBrandId || 'uncategorised';
      const brandFilter = props.brandFilters.find(f => f.id === brandId);
      const isBrandMatched = brandFilter ? brandFilter.checked : true;

      const categoryId = product.productCategoryId || 'uncategorised';
      const categoryFilter = props.categoryFilters.find(f => f.id === categoryId);
      const isCategoryMatched = categoryFilter ? categoryFilter.checked : true;

      const isSearchMatched = props.searchText ? product.name.toLowerCase()
        .includes(props.searchText.toLowerCase()) : true;

      return isBrandMatched && isCategoryMatched && isSearchMatched;
    });

    return {
      products,
      allBrandsChecked: props.brandFilters.every(f => f.checked),
      allCategoriesChecked: props.categoryFilters.every(f => f.checked),
    };
  }),
);
